export default function buildQuery(tags) {
    return tags.reduce((acc, tag) => {
        return acc + `&tags[]=${tag}`;
    }, '');
}